export const LOGO = "/assets/kelifa-logo.jpg";

export const TAG_LABELS = {
  "mas-vendido": "Más vendido",
  "nuevo": "Nuevo",
  "temporada": "De temporada",
  "bajo-pedido": "Bajo pedido",
};

// bg color + whether it should shimmer/pulse
export const TAG_STYLE = {
  "mas-vendido": { bg: "#C8943F", animated: false },
  "nuevo": { bg: "#9BA77D", animated: true },
  "temporada": { bg: "#DCA9B5", animated: true },
  "bajo-pedido": { bg: "#4B1025", animated: false },
};

export const ORDER_STATUSES = [
  { value: "nuevo", label: "Nuevo", color: "#C8943F" },
  { value: "revision", label: "En revisión", color: "#DCA9B5" },
  { value: "confirmado", label: "Confirmado", color: "#9BA77D" },
  { value: "preparacion", label: "En preparación", color: "#761B38" },
  { value: "listo", label: "Listo", color: "#4B1025" },
  { value: "entregado", label: "Entregado", color: "#2F211D" },
  { value: "cancelado", label: "Cancelado", color: "#b0b0b0" },
];

export const PAYMENT_STATUSES = [
  { value: "pendiente", label: "Pendiente" },
  { value: "anticipo", label: "Anticipo recibido" },
  { value: "pagado", label: "Pagado" },
];

export const PAYMENT_METHODS = ["Efectivo", "Transferencia", "Depósito", "Otro"];

export const QUOTE_STATUSES = [
  { value: "nueva", label: "Nueva" },
  { value: "revision", label: "En revisión" },
  { value: "cotizada", label: "Cotizada" },
  { value: "aceptada", label: "Aceptada" },
  { value: "rechazada", label: "Rechazada" },
  { value: "cancelada", label: "Cancelada" },
];

export const statusMeta = (v) => ORDER_STATUSES.find((s) => s.value === v) || ORDER_STATUSES[0];
